module.exports = __webpack_public_path__ + "img/IFEA-Treuhand-GmbH-ICON.e2d9857d.png";